export const manage = "manage";
export const view = "view";
export const create = "create";
export const edit = "edit";
export const del = "delete";

export const Client = "Client";

export const User = "User";
export const Role = "Role";
export const Subject = "Subject";
export const Config = "Config";
export const Template = "Template";
export const SecQuestion = "SecQuestion";
export const Device = "Device";
export const AppVersion = "AppVersion";
export const Parameter = "Parameter";

export const Citizen = "Citizen";
export const AccountRegister = "AccountRegister";
export const SendOTP = "SendOTP";

export const Foreigner = "Foreigner";
export const ForeignerRegister = "ForeignerRegister";

export const Unit = "Unit";
export const Country = "Country";
export const Nation = "Nation";
export const Religion = "Religion";
export const Division = "Division";
export const BloodGroup = "BloodGroup";
export const Relation = "Relation";
export const Gender = "Gender";
export const Nationality = "Nationality";

export const MaritalStatus = "MaritalStatus";
export const Crime = "Crime";
export const DrivingLicenseClass = "DrivingLicenseClasses";
export const Education = "Education";
export const Language = "Language";
export const Specialize = "Specialize";
export const LicensingAgency = "LicensingAgency";
export const SysCategory = "SysCategory";
export const Job = "Job";
export const AccountRegisterHistory = "AccountRegisterHistory";
export const UserTransaction = "UserTransaction";
export const NotificationLog = "NotificationLog";
export const DependentHistory = "DependentHistory";
export const PersonInfo = "PersonInfo";
export const ApprovalResult = "ApprovalResult";
export const ProcessingStatus = "ProcessingStatus";
export const NotificationEvent = "NotificationEvent";
export const SendReceptData = "SendReceptData";
export const RequestLookup = "RequestLookup";
export const ForeignerPersonal = "ForeignerPersonal";
export const UserQrcode = "UserQrcode";
export const ProcessStatusForeign = "ProcessStatusForeign";
export const ActionJob = "ActionJob";
export const VNeIDJob = "VNeIDJob";
export const DashboardReport = "DashboardReport";
export const JudicialRecords = "JudicialRecords";

export const SmsLog = "SmsLog";
export const EmailLog = "EmailLog";
export const IdpEventLog = "IdpEventLog";
export const IdpAdminEventLog = "IdpAdminEventLog";

export const X_TOTAL_COUNT = "x-total-count";
